import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryOutcomeOfARTDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfART/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryOutcomeOfARTList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfART/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryOutcomeOfART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfART/Create`, data);

export const UpdateRefHistoryOBGyHistoryOutcomeOfART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfART/Update`, data);

export const DeleteRefHistoryOBGyHistoryOutcomeOfART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfART/Delete`, data);